import './Header.css';
import React from "react";
import ftf from "../assets/images/ftf.png";
import waterBall from "../assets/images/waterBall.svg";

function Header(props) {

    return (
        <div className="header">
        <div className="navBar">
            {props.activeTab !== "home" &&
                <button className= "tab homeTab" onClick={() => props.setActiveTab("home")}>- back to home -</button>
            }
            <button className={(props.activeTab === "curriculum") ? "tab activeTab" : "tab"} onClick={() => props.setActiveTab("curriculum")}>- curriculum -</button>
            <button className={(props.activeTab === "about") ? "tab activeTab" : "tab"} onClick={() => props.setActiveTab("about")}>- about ftfaa -</button>
            <button className={(props.activeTab === "apply") ? "tab activeTab" : "tab"} onClick={() => props.setActiveTab("apply")}>- apply  -</button>
        </div>
        <img className="waterBall waterLeft" src={waterBall} alt="3d ball of water"></img>
            <img className="Logo" src={ftf} alt="bubble white chrome text reading Future Tech Founders, in all caps"></img>
            <img className="waterBall waterRight" src={waterBall} alt="3d ball of water"></img>
            <p className="subheaderText"> accelerator academy</p>
        </div>
    )
}

export default Header;